import { object, string } from '@gogame/schemas';

import { NAME, EMAIL, POSITION, DEPARTMENT, COMPANY } from './constants';

export const userSchema = object({
  [NAME]: string().required('Full name is required'),
  [EMAIL]: string().required('Email is required'),
  [POSITION]: string().required('Position is required'),
  [DEPARTMENT]: string().required('Department is required'),
  [COMPANY]: string().required('Company is required'),
});
